import { render, staticRenderFns } from "./GestionComando.vue?vue&type=template&id=586cbe26"
import script from "./GestionComando.vue?vue&type=script&lang=js"
export * from "./GestionComando.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports